import { signal } from '@angular/core';

/**
 * A static class to update the breadcrumb for the sub-navbar
 * We use this instead of service, because service would be just too much, and since
 * this only holds one value at a time
 */
export class MainLayoutStore {
    public static readonly breadcrumb = signal<string>('');

    /**
     * A static setter to update the breadcrumb for the sub-navbar
     * @param {string} breadcrumb The breadcrumb text to display in the sub-navbar breadcrumb
     */
    public static setBreadcrumb(breadcrumb: string): void {
        this.breadcrumb.set(breadcrumb);
    }

    /**
     * Clear breadcrumb, must be called always in the ngOnDestory lifecycle of the consuming component
     */
    public static clearBreadcrumb(): void {
        this.breadcrumb.set('');
    }
}
